export default __webpack_public_path__ + "static/media/cancel.8a326e85.png";